import { render } from "./EditorMessage.vue?vue&type=template&id=736199a8&ts=true"
import script from "./EditorMessage.vue?vue&type=script&lang=ts"
export * from "./EditorMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__